export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-radio/index.js